export default __webpack_public_path__ + "static/media/filter-icon.c7494f61.svg";